import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "routing-addresses-loading" }
const _hoisted_2 = { class: "routing-addresses-loading__inner" }

import Card from 'vcomponents/common/card/Card.vue';
import { CardSize } from 'types/components/common/Card.type';

const CARD_COUNT = 2;

export default /*@__PURE__*/_defineComponent({
  __name: 'RoutingAddressesLoading',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_CompassSkeleton = _resolveComponent("CompassSkeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(CARD_COUNT, (cardIndex) => {
      return _createVNode(Card, {
        key: cardIndex,
        size: _unref(CardSize).MEDIUM
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_CompassSkeleton, {
              class: "routing-addresses-loading__header",
              variant: _ctx.CompassEnums.SkeletonVariantType.LINE,
              size: _ctx.CompassEnums.SkeletonSize.LARGE
            }, null, 8 /* PROPS */, ["variant", "size"]),
            _createVNode(_component_CompassSkeleton, {
              class: "routing-addresses-loading__footer",
              variant: _ctx.CompassEnums.SkeletonVariantType.LINE,
              size: _ctx.CompassEnums.SkeletonSize.MEDIUM
            }, null, 8 /* PROPS */, ["variant", "size"])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    }), 64 /* STABLE_FRAGMENT */))
  ]))
}
}

})